module.exports = __webpack_public_path__ + "static/media/主控模块.f98ef188.png";